import styled from 'styled-components';
import { ReactComponent as CopyIcon } from 'src/assets/icons/bonus-game/copy-icon.svg';
import { ReactComponent as CheckIcon } from 'src/assets/icons/check.svg';
import { useEffect, useState } from 'react';
import { HorizontalView } from 'src/components/FlexViews';

const PromoCodeContainer = styled.div`
  background: rgba(150, 150, 150, 0.15);
  border-radius: 12px;
  padding: 14px;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

const PromoCode = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  flex: 1;
  text-align: center;
  margin-left: 15px;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #c4f538;
`;

const CopyText = styled.p`
  font-size: 12px;
`;

interface PromocodeProps {
  promoCode: string;
}

export const Promocode = ({ promoCode }: PromocodeProps) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false);
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [copied]);

  const handleCopyPromoCode = () => {
    (window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({ type: 'copy-to-clipboard', data: { text: promoCode } }),
    );
    setCopied(true);
  };
  return (
    <PromoCodeContainer>
      {copied && (
        <HorizontalView
          style={{
            position: 'absolute',
            top: '-28px',
            right: '0',
            padding: '4px 14px',
            backgroundColor: '#313845',
            borderRadius: '32px',
            gap: '4px',
            zIndex: '100',
          }}>
          <CheckIcon width={14} height={14} />
          <CopyText>Copied</CopyText>
        </HorizontalView>
      )}
      <PromoCode>{promoCode}</PromoCode>
      <CopyButton onClick={handleCopyPromoCode}>
        <CopyIcon width={24} height={24} />
      </CopyButton>
    </PromoCodeContainer>
  );
};
